import { createElementBlock as o, openBlock as t, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
};
function l(c, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("circle", {
      cx: "8.5",
      cy: "8.5",
      r: "8.5",
      fill: "currentColor"
    }, null, -1),
    r("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m5.514 9.083 2.459 1.944 3.513-4.595"
    }, null, -1)
  ])]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
